import { load, initDeployments, abort, getActive, globalListenerStore } from './app';

const Pastease = {
	load,
	forceParse: initDeployments,
	abort,
	getActive,
	trackEvent: globalListenerStore.trackEvent,
	getTrail: globalListenerStore.getTrail,
};

window.Pastease = Pastease;
window.mopinionDeploy = Pastease;

export default Pastease;
